import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{attrs:{"outlined":""}},[_c(VCardText,[(_vm.name)?_c('strong',[_vm._v(_vm._s(_vm.name))]):_vm._e(),(_vm.name)?_c('hr'):_vm._e(),_c('div',[_c('apexchart',{attrs:{"type":"bar","height":_vm.height,"options":_vm.chartOptions,"series":_vm.data.series}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }